export function searchParamsSplitter(params) {
    if( ! params ) return;
  
    let results = {};
    let searchParam = params.search.substring(1); //remove ?
    let searchParamArr = searchParam.split('&'); //split for multi params
  
    searchParamArr.forEach(param => {
      let singleParam = param.split('=');
      results[singleParam[0]] = singleParam[1];
    });
  
    return results;
 
}